<template>
  <VModal name="save-update-party-message-modal" class="modal-party-message" :loading="loading" @onOpen="onOpenModal">
    <template v-slot:header>
      <h2 class="o-modal__box__header">{{ $t('createEnvelope.documentSetup.partySelection.saveNewMessageTemplate') }}</h2>
    </template>
    <template v-slot:content>
      <VForm :onSubmit="validateForm" :data-vv-scope="`save-party-message-${order}`">
        <div slot="row">
          <VInput
            type="text"
            :class="{ 'a-input--error': errors.has(`save-party-message-${order}.message-name`) }"
            v-model="messageData.name"
            placeholder="e.g. Welcome Message"
            data-vv-name="message-name"
            data-vv-as="message name"
            v-validate="'required|min:3'"
            :data-vv-scope="`save-party-message-${order}`"
            data-test="input-message-name"
            data-hj-suppress
            data-ec="save_update_party_message_modal"
            data-et="message_name_input" />
          <VMessage
            type="error"
            subtype="basic"
            v-show="errors.has(`save-party-message-${order}.message-name`)">
            <template v-slot:icon>
              <XMarkIcon />
            </template>
            <template v-slot:text>
              {{ errors.first(`save-party-message-${order}.message-name`) }}
            </template>
          </VMessage>
        </div>
        <div slot="formButtons">
          <VButton
              type="success"
              class="float-right"
              subtype="submit"
              href="#"
              data-ec="save_update_party_message_modal"
              data-et="save_message_button">
            <PlusIcon />
            <span>{{ $t('createEnvelope.documentSetup.partySelection.saveTemplate') }}</span>
          </VButton>
        </div>
      </VForm>
    </template>
  </VModal>
</template>

<script>
import VButton from '@/components/deprecated/atoms/Button.vue';
import VInput from '@/components/deprecated/atoms/Input.vue';
import VMessage from '@/components/deprecated/atoms/Message.vue';
import VForm from '@/components/deprecated/organisms/Form.vue';
import VModal from '@/components/deprecated/organisms/Modal.vue';
import { PlusIcon, XMarkIcon } from '@/components/icons/fontIcons';
import validation from '@/utils/validation';

export default {
  name: 'SaveUpdatePartyMessageModal',
  inject: {
    $validator: '$validator',
  },
  components: {
    VButton,
    VInput,
    VMessage,
    VForm,
    VModal,
    PlusIcon,
    XMarkIcon,
  },
  data() {
    return {
      validation,
      loading: false,
      messageData: {
        name: '',
      },
    };
  },
  props: {
    message: {
      type: [String],
      required: false,
    },
    order: {
      type: [Number],
      required: true,
    },
  },
  methods: {
    onOpenModal() {
      // if (this.message.name) {
      //   this.messageName = this.message.name;
      // }
    },
    validateForm(scope) {
      this.$validator.validateAll(scope).then(async (validated) => {
        const combinedMessage = {
          name: this.messageData.name,
          text: this.message,
        };

        const closeModal = () => {
          this.loading = false;
          this.$bus.$emit('closeModal');
          this.messageData.text = '';
        };

        if (validated) {
          this.loading = true;
          try {
            await this.$store.dispatch('company/ADD_MESSAGE', combinedMessage);
            closeModal();
          } catch (e) {
            this.loading = false;
            if (e.response && e.response.data && e.response.data.errors && e.response.data.errors.name) {
              this.errors.add({
                field: 'message-name',
                msg: e.response.data.errors.name[0],
                scope,
              });
              return;
            }
            closeModal();
          }
        }
      });
    },
  },
};
</script>
